// @ts-nocheck
import { Overlay } from '@angular/cdk/overlay';
import { NgStyle, NgTemplateOutlet } from '@angular/common';
import {
  Component,
  ElementRef,
  EventEmitter,
  HostBinding,
  Input,
  OnDestroy,
  Output,
  TemplateRef,
  ViewChild,
  inject,
} from '@angular/core';
import { IconComponent } from '@lbca-shared/icon';
import { ASSETS } from '../../../../assets/assets';
import { ErrorOverlayClass } from '../../error-overlay/error-overlay.directive';
import {
  PopupFeedbackDirective,
  PopupInterfaceCommunication,
} from '../../popup-feedback/popup-feedback.directive';
import { MaskHelper } from './mask-input.helper';

@Component({
  selector: 'lbca-input-text',
  templateUrl: './input-text.component.html',
  styleUrl: './input-text.component.scss',
  imports: [IconComponent, NgTemplateOutlet, NgStyle],
})
export class InputTextComponent implements OnDestroy {
  public popupFeedController = new PopupInterfaceCommunication();
  readonly assets = inject(ASSETS);

  private maskHelper: any = null;

  @Input() set maskInput(maskType: string) {
    if (maskType) this.maskHelper = new MaskHelper(maskType, undefined as any, this.assets);

    if (maskType && this.maskHelper) {
      this.hasMask = true;

      this.setValueUserEventToMaskCallback = (value, cursorPosition) => {
        const { newValue, newCursorPosition } = this.maskHelper.getPureValue(value, cursorPosition);
        const { formatedValue, formatedCursorPosition } = this.maskHelper.getMaskedValue(
          newValue,
          newCursorPosition
        );
        return { pureValue: newValue, formatedValue, formatedCursorPosition };
      };
      this.setValueInputToMaskCallback = (value) => {
        const { formatedValue } = this.maskHelper.getMaskedValue(value, value.length);
        return formatedValue;
      };
      this.validateCallback = async (value) => {
        return {
          isValid: await this.maskHelper.validate(value),
          insertIcon: this.maskHelper.getInsertIconValidate(),
        };
      };
      this.getMaskErrorCallback = () => {
        return this.maskHelper.getError();
      };
      this.formatOutputValueCallback = async (value) => {
        return await this.maskHelper.formatOutputValue(value);
      };
      this.validateAllDigitCallback = this.maskHelper.validateAllDigit();
    }
  }

  @HostBinding('attr.lbcaPopupFeedback') popupFeedback = new PopupFeedbackDirective(
    this.overlay,
    this.popupFeedController
  );

  @ViewChild('templateCopy') templateCopy!: TemplateRef<any>;

  public errorPopup!: ErrorOverlayClass;

  @ViewChild('inputData', { static: true }) inputData!: ElementRef;

  public hasMask = false;

  public isTouched = false;
  public hasError = false;
  public isRequired = false;
  public isReferenced = false;
  public isDisabled = false;
  public isEditable = false;
  public isLoadingState = false;
  public validateAllDigitCallback = true;

  public isValidIcon = false;
  public isLabeled = false;
  public isTabeled = false;
  public copy = true;

  public labelValue = '';
  public helperTextValue = '';
  public placeholder = '';
  public removeData: any = null;

  public maskIcon: any = null;

  public inputComponetIconSize: 'sm' | 'normal' = 'normal';
  public inputComponetHelperIconStyle: any = null;
  public inputComponetHelperIconLeftStyle: any = null;

  public componentFilling: any = null;

  public valueToReturn: any = '';
  public _fieldMetadata: any = {};

  public readInputTimeOutDebounce: any = null;
  public timeOutSendValue: any = null;

  public setValueUserEventToMaskCallback: any = null;
  public setValueInputToMaskCallback: any = null;
  public validateCallback: any = null;
  public getMaskErrorCallback: any = null;
  public formatOutputValueCallback: any = null;

  public formatedValue!: any;

  public maxChars!: number;
  public minChars!: number;
  public enableCount: boolean = true;
  public type: 'countup' | 'countdown' = 'countdown';
  public errorCtrl: boolean = false;
  public limitFeedback = '';

  constructor(public overlay: Overlay, elementRef: ElementRef) {
    this.errorPopup = new ErrorOverlayClass(overlay);
    this.errorPopup.setPosition(
      elementRef,
      [
        {
          originX: 'end',
          originY: 'bottom',
          overlayX: 'end',
          overlayY: 'top',
        },
      ],
      0,
      0,
      'top',
      'end'
    );
  }

  @Input() set referenced(value: boolean) {
    this.isReferenced = value;
  }
  @Input() set tabeled(value: boolean) {
    this.isTabeled = value;
  }
  @Input('placeholder') set placeholderValue(value: string) {
    this.placeholder = value;
  }
  @Input() set labeled(value: boolean) {
    this.isLabeled = !value;
  }
  @Input() set editable(value: boolean) {
    this.isEditable = value;
  }
  @Input() set require(status: boolean) {
    this.isRequired = status;
  }
  @Input() set loadingState(status: boolean) {
    this.isLoadingState = status;
  }
  @Input() set disabled(disabled: boolean) {
    this.isDisabled = disabled;
  }
  @Input() set helperText(value: string) {
    this.helperTextValue = value;
  }
  @Input() set label(value: string) {
    this.labelValue = value;
  }
  @Input() set remove(value: any) {
    this.removeData = value;
  }
  @Input() set hasExternalError(value: boolean) {
    this.hasError = value;
  }
  @Input() set copyContent(value: boolean) {
    this.copy = value;
  }
  @Input() iconRight: any = null;

  @Input() set componetHelperIconStyle(icon: string) {
    this.inputComponetHelperIconStyle = icon;
  }
  @Input() set componetHelperIconLeftStyle(icon: string) {
    this.inputComponetHelperIconLeftStyle = icon;
  }
  @Input() set componetIconSize(icon: 'sm' | 'normal') {
    this.inputComponetIconSize = icon;
  }
  @Input() set fieldMetadata(value: any) {
    this._fieldMetadata = value;
  }
  @Input() set spacing(value: string) {
    this.componentFilling = value;
  }

  @Input() componetIconStyle: any;

  @Input() set rules(value: any) {
    if (value?.minSize) this.minChars = value.minSize;
    if (value?.maxSize) this.maxChars = value.maxSize;
  }

  @Input() autocomplete: string = 'on';
  @Input() id: string = '';
  @Input() name: string = '';
  @Input() inputError: any = null;

  @Input('error')
  set err(error) {
    if (error && error.length > 0) {
      this.hasError = true;
      this.errorPopup.setErrors(error);
    } else {
      this.hasError = false;
      this.errorPopup.setErrors([]);
    }
  }

  @Input()
  set focus(value: boolean) {
    if (value) this.inputData!.nativeElement.focus();
  }

  @Input()
  set value(value) {
    if (value) {
      // await mask initialization
      setTimeout(async () => {
        this.valueToReturn = value;
        this.isTouched = true;

        const { formatedValue } = this.setValueUserEventToMaskCallback
          ? this.setValueUserEventToMaskCallback(value, 0)
          : { formatedValue: value };
        this.inputData!.nativeElement.value = formatedValue;
        this.formatedValue = formatedValue;

        // await this.formatValidation();
        this.changeEmmiter.emit(await this.formaterValue(this.valueToReturn));
      }, 5);
    } else if (value === '') {
      this.isTouched = false;
      this.inputData!.nativeElement.value = '';
    }
  }

  @Output('removeAction') confirmRemoveEmmitter = new EventEmitter();
  @Output('changeValue') changeEmmiter = new EventEmitter();
  @Output('submitForm') submitActionEmmiter = new EventEmitter();
  @Output() valueChange = new EventEmitter();

  @Output() focusState = new EventEmitter();

  @Output('setError') setErrorEmmiter = new EventEmitter();
  @Output('validStatus') validStatusEmmiter = new EventEmitter();

  ngOnDestroy(): void {
    this.hasError = false;
    this.validStatusEmmiter.emit(false);
    this.setErrorEmmiter.emit([]);
  }

  public async formaterValue(value) {
    if (this.hasMask) {
      const fomatedValue = await this.formatOutputValueCallback(value);
      return fomatedValue;
    }
    return value;
  }

  /**
   *
   * @param code códiga da tecla pressionada
   * @param target elemento do html que está sendo alterado
   */
  public processMask(target: HTMLInputElement, code?: string, value?: any) {
    this.readInputTimeOutDebounce = setTimeout(async () => {
      this.valueToReturn = target.value;
      if (value) this.valueToReturn = value;

      const cursorStart = target.selectionStart;

      // Se este input possuir uma máscara, executa a função de interpretação, senão simplesmente mantém os valores sem alterações
      const { pureValue, formatedValue, formatedCursorPosition } = this
        .setValueUserEventToMaskCallback
        ? this.setValueUserEventToMaskCallback(this.valueToReturn, cursorStart)
        : {
            pureValue: this.valueToReturn,
            formatedValue: this.valueToReturn,
            formatedCursorPosition: cursorStart,
          };

      this.valueToReturn = pureValue ?? this.valueToReturn; // valor de retorno sem mascara "pureValue", que deve ser eviado para o backend;
      this.formatedValue = formatedValue ?? this.formatedValue;

      if (target) target.value = formatedValue;
      if (code?.substring(0, 5) === 'Arrow') return;
      if (code?.substring(0, 5) === 'Shift') return;
      if (code?.substring(0, 7) === 'Control') return;

      if (target) {
        if (target.selectionEnd === target.selectionStart) {
          target.selectionEnd = formatedCursorPosition;
          target.selectionStart = formatedCursorPosition;
        }
      }

      if (this.validateAllDigitCallback) {
        await this.formatValidation();
      } else {
        this.setErrorEmmiter.emit([]);
      }

      this.sendEventToChangeInterceptor(code);
    }, 25);
  }

  public async sendEventToChangeInterceptor(code?: string) {
    const value = await this.formaterValue(this.valueToReturn);

    clearTimeout(this.timeOutSendValue);

    this.timeOutSendValue = setTimeout(async () => {
      this.changeEmmiter.emit(value);
      this.valueChange.emit(value);
    }, 250);
    if (code?.substring(0, 5) === 'Enter') this.submitActionEmmiter.emit(true);
  }

  public inputKeyUpEvent($event: KeyboardEvent) {
    const { code, target } = $event;

    // if ($event.ctrlKey === true) return;

    clearTimeout(this.readInputTimeOutDebounce);
    this.hasError = false;
    this.isValidIcon = false;
    this.processMask(target as HTMLInputElement, code);
  }

  public clickPaste($event: ClipboardEvent) {
    clearTimeout(this.readInputTimeOutDebounce);
    this.hasError = false;
    this.isValidIcon = false;
    const { target } = $event;
    this.processMask(target as HTMLInputElement);
  }

  public copyPasteKeyUpEvent($event: KeyboardEvent): void {
    clearTimeout(this.readInputTimeOutDebounce);
    this.hasError = false;
    this.isValidIcon = false;
    const { code, target } = $event;
    this.processMask(target as HTMLInputElement, code);
  }

  public click() {
    if (this.isEditable) {
      this.isLabeled = false;
      this.isTouched = true;
      this.focusState.emit(true);
    }
  }

  public preventDefault($event) {
    $event.preventDefault();
  }

  public stopPropagation($event) {
    $event.stopPropagation();
  }

  public focusIn(): void {
    this.isTouched = true;
    this.focusState.emit(true);
    this.errorPopup.setFocus(true);
  }

  public async focusOut() {
    setTimeout(async () => {
      if (!this.inputData!.nativeElement?.value) this.isTouched = false;
      this.formatValidation();
      this.errorPopup.setFocus(false);
      if (this.isEditable) this.isLabeled = true;
    }, 100);

    this.focusState.emit(false);
    const value = await this.formaterValue(this.valueToReturn);
    this.changeEmmiter.emit(value);
    this.valueChange.emit(value);
  }

  public async formatValidation() {
    if (!this.valueToReturn) {
      this.validStatusEmmiter.emit(false);
      return;
    }

    if (this.maxChars || this.minChars) {
      const charsControlResult = this.charsControl(this.valueToReturn);
      if (this.errorCtrl) {
        this.hasError = true;
        this.validStatusEmmiter.emit(false);
        this.setErrorEmmiter.emit([charsControlResult]);
        return;
      }
    }

    if (this.hasMask) {
      const { isValid, insertIcon } = await this.validateCallback(this.formatedValue);

      if (insertIcon) this.isValidIcon = isValid;

      if (isValid) {
        this.hasError = false;
        // Zera o erro
        this.setErrorEmmiter.emit([]);
        // if (this._fieldMetadata?.entityKey === 'cnj')
        this.validStatusEmmiter.emit(true);
      } else {
        this.hasError = false;
        this.validStatusEmmiter.emit(false);
        // Joga o erro pra ele mesmo, pra pegar no set, e conseguir deixar o controle externo,
        // pra inserção de erro de api, o erro de campo obrigatório é colocado pelo módulo,
        // sendo assim não depende do form aberto.
        this.setErrorEmmiter.emit(this.getMaskErrorCallback());
      }
    } else {
      this.hasError = false;
      this.validStatusEmmiter.emit(true);
      this.setErrorEmmiter.emit([]);
    }
  }

  public confirmRemoveEvent($event, line) {
    const sendLine = { $event, line };
    this.confirmRemoveEmmitter.emit(sendLine);
  }

  public copyToClipboard($event): void {
    $event.preventDefault();
    $event.stopPropagation();
    navigator.clipboard.writeText(this.inputData.nativeElement!.value).then(() => {
      this.popupFeedController.show(this.templateCopy);
      setTimeout(() => this.popupFeedController.close(), 4000);
    });
  }

  public charsControl(input) {
    if (this.isDisabled) return;

    const size = input.length || 0;
    let msg;

    if (this.maxChars) {
      const totalchars = this.maxChars - size;

      if (this.type === 'countdown') {
        if (totalchars < 0) {
          this.errorCtrl = true;
          msg = `Limite excedido em ${-totalchars} caracteres.`;
        } else if (this.minChars) {
          if (totalchars > this.maxChars - this.minChars) {
            this.errorCtrl = true;
            msg = `O texto deve conter ao menos ${this.minChars} caracteres.`;
          } else {
            this.errorCtrl = false;
            msg = totalchars;
          }
        } else {
          this.errorCtrl = false;
          msg = totalchars;
        }
      } else {
        if (size > this.maxChars) {
          this.errorCtrl = true;
          msg = `${this.maxChars - size} / ${this.maxChars}`;
        } else {
          this.errorCtrl = false;
          msg = `${size} / ${this.maxChars}`;
        }
      }
      return msg;
    } else if (this.minChars) {
      if (size < this.minChars) {
        this.errorCtrl = true;
        msg = `O texto deve conter ao menos ${this.minChars} caracteres.`;
      } else {
        this.errorCtrl = false;
        msg = `${size}`;
      }
      return msg;
    }
  }
}
